<template>
  <item-section
    ref="section"
    v-model="constraintType"
    title="省"
    @change="handleChangeConstraintType"
  >
    <template v-slot:allowed>
      <cascade-province-selector
        v-model="allowedData"
        :data-source="dataSource"
        class="flex-fill"
        style="overflow: hidden;"
      />
    </template>
    <template v-slot:forbidden>
      <cascade-province-selector
        v-model="forbiddenData"
        :data-source="dataSource"
        class="flex-fill"
        style="overflow: hidden;"
      />
    </template>
  </item-section>
</template>
<script>
import ItemSection from "@/components/excel/designer/template/area/cascade/ItemSection";
import CascadeProvinceSelector from "@/components/excel/designer/template/area/cascade/selector/ProvinceSelector";

export default {
  name: "cascade-province-section",
  components: { CascadeProvinceSelector, ItemSection },
  props: {
    forbiddenValues: {
      type: Array,
    },
    allowedValues: {
      type: Array,
    },
    dataSource: {
      type: Array,
    },
  },
  computed: {
    allowedData: {
      get() {
        return this.$props.allowedValues;
      },
      set(value) {
        this.changeAllowed(value);
      },
    },
    forbiddenData: {
      get() {
        return this.$props.forbiddenValues;
      },
      set(value) {
        this.changeForbidden(value);
      },
    },
  },
  data() {
    return {
      constraintType: 1,
    };
  },
  methods: {
    handleChangeConstraintType(value) {
      const { section } = this.$refs;
      if (section) {
        if (section.isLatest(value)) {
          // 永远取最新的
          this.changeAllowed(null);
        } else if (section.isCurrent(value)) {
          // 取当前的所有
          this.changeAllowed(this.getAllIds());
        }
      }
    },
    changeAllowed(value) {
      this.$emit("change-allowed-values", value);
    },
    changeForbidden(value) {
      this.$emit("change-forbidden-values", value);
    },
    getAllIds() {
      const { dataSource } = this.$props;
      return dataSource.map((it) => it.id);
    },
  },
};
</script>
